import { AxiosError, AxiosResponse } from 'axios';
import { axiosUnauthorized } from 'config/axios';
import { RestorePasswordResponse } from 'types/embedded/auth';

export const sendRestorePasswordLink = async (
  reddyNumber: string,
): Promise<RestorePasswordResponse> => {
  return axiosUnauthorized
    .post('restore_password', { reddyNumber })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const sendNewPassword = async (
  token: string,
  password: string,
): Promise<RestorePasswordResponse> => {
  return axiosUnauthorized
    .post('new_password', { token, password })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

type ResendCodeResponse = {
  code: string;
  message: string;
};

export const resendCode = async (token: string): Promise<ResendCodeResponse> => {
  return axiosUnauthorized
    .post('resend_code', { token })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
